import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Images from '../../Images/Img';

const Main = () => {

  const navigate = useNavigate();

  return (
    <div className="main-wrapper login-body">
      <div className="container-fluid px-0">
        <div className="row">
          <div className="col-lg-6 login-wrap">
            <div className="login-sec">
              <div className="log-img">
                <img className="img-fluid" src="/assets/img/login-img.png" alt="Logo" />
              </div>
            </div>
          </div>
          <div className="col-lg-6 login-wrap-bg">
            <div className="login-wrapper">
              <div className="loginbox">
                <div className="login-right">
                  <div className="login-right-wrap">
                    <div className="account-logo login-vlogo">
                      <Link to="/user/login"><img src={Images.Logo} alt="account-logo" /></Link>
                      {/* <Link to="/user/login"><img src="/assets/img/login-vlogo.svg" alt="account-logo" /></Link> */}
                    </div>

                    <h2>Vitthalesh Engineering Login</h2>

                    <form>
                      <div className="input-block login-btn">
                        <button className="btn-block  btn btn-primary" type="button" onClick={() => navigate('/admin/login')}>Admin Login</button>
                        {/* <button className="btn-block  btn btn-primary mt-4" type="button" onClick={() => window.open('https://payroll.vrishal.in/user/login', '_blank')}>Payroll User Login</button> */}
                        <button className="btn-block  btn btn-primary mt-4" type="button" onClick={() => navigate('/user/login', { state: { type: true } })}>Main Store Login</button>
                        <button className="btn-block  btn btn-primary mt-4" type="button" onClick={() => navigate('/user/login', { state: { type: false } })}>PMS Login</button>
                        <button className="btn-block  btn btn-primary mt-4" type="button" onClick={() => window.open('https://vitthaleshaccount.addonwebtech.com/login', '_blank')}>Account Login</button>
                      </div>
                    </form>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Main